module.exports = __webpack_public_path__ + "static/media/mw.43ff7ada.svg";